import { serviceRequestTableLocalTime } from 'src/helpers/validationHelper';
import FontAwesomeIcon from 'src/components/Icon';
import Button from 'src/components/Button';

export const createPDFRequestTableColumns = (
  exportPDF: any,
  editPdfname: any,
  onDeletePDFfile: any
) => {
  return [
    {
      label: 'File Name',
      accessor: 'fileName',
      cell: (data: any) => data.fileName,
      style: { width: '40%' },
    },
    {
      label: 'Requested By',
      accessor: 'requestedName',
      cell: (data: any) => data.requestedName,
    },
    {
      label: 'Requested Date',
      accessor: 'requestedDate',
      cell: (data: any) => serviceRequestTableLocalTime(data.requestedDate),
    },
    {
      label: 'Action',
      accessor: 'pdfurl',
      cell: (data: any) =>
        data.pdfurl !== null ? (
          <>
            <Button
              color="semantic"
              label={<FontAwesomeIcon glyph="download" weight="light" />}
              onClick={() => exportPDF(data.pdfurl)}
            />
            <span
              style={{ marginLeft: '10px', cursor: 'pointer' }}
              onClick={(e) => editPdfname(e, data)}
            >
              <FontAwesomeIcon glyph="pencil" weight="light" />
            </span>
            <span
              style={{ marginLeft: '10px', cursor: 'pointer' }}
              onClick={() =>
                window.confirm(
                  `Are you sure you want to delete ${data.fileName !== null ? data.fileName : ''}?`
                ) && onDeletePDFfile(data.id)
              }
            >
              <FontAwesomeIcon glyph="trash" weight="light" />
            </span>
          </>
        ) : (
          <>
            <span style={{ marginRight: '10px' }}> N/A </span>
            <span
              style={{ marginRight: '10px', cursor: 'pointer' }}
              onClick={(e) => editPdfname(e, data)}
            >
              <FontAwesomeIcon glyph="pencil" weight="light" />
            </span>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() =>
                window.confirm(
                  `Are you sure you want to delete ${data.fileName !== null ? data.fileName : ''}?`
                ) && onDeletePDFfile(data.id)
              }
            >
              <FontAwesomeIcon glyph="trash" weight="light" />
            </span>
          </>
        ),
    },
  ];
};
